import {
  AdvancedFormatOpenType,
  AdvancedFormatRenderer,
  CardLayouts,
} from '@loyalty/editor-components';
import { Editor } from 'grapesjs';
import { faDice } from '@fortawesome/pro-solid-svg-icons/faDice';
import {
  AdvancedFormatWidgetTraits,
  advancedFormatWidgetTraitsSchema,
} from './AdvancedFormatWidgetTraits';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { buildParticipantContextFromGrape } from '../../utils';

export const advancedFormatComponentDefinition: EditorComponentDefinition = {
  id: 'advanced-format',
  icon: faDice,
  category: 'Interactive elements',
  getLabel: ({ t }) => t('editor.component.advanced-format'),
  component: AdvancedFormatWidget,
  traits: {
    schema: advancedFormatWidgetTraitsSchema,
    form: AdvancedFormatWidgetTraits,
  },
};

function AdvancedFormatWidget(editor: Editor) {
  const context: EditorContext = editor.Config.context;
  const languages = editor.Config?.context?.languages || [];
  const i18n = editor.I18n;
  const defaultI18nAttributes = Object.fromEntries(
    languages.map((l: string) => [l, { title: '', image: '', description: '', ctaLabel: '' }]),
  );

  editor.DomComponents.addType(advancedFormatComponentDefinition.id, {
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
    model: {
      defaults: {
        attributes: {
          openType: AdvancedFormatOpenType.iframe,
          template: CardLayouts.DEFAULT,
        },
        i18nAttributes: defaultI18nAttributes,
        draggable: '[data-gjs-type=column]',
        droppable: false,
        editable: true,
        traits: [],
      },
      toHTML() {
        return `<div class="qlfeditor-non-interactive-component">
          <div class="qlfeditor-non-interactive-hover-mask">
            <p>${i18n.t('editor.non-interactive.hover.mask')}</p>
          </div>
          ${AdvancedFormatRenderer(
            {
              state: { ...context.widgetState, programId: context.programId }, // TODO: maybe widgetState should have the correct programId and not the fixture one
              options: {
                id: this.getId(),
                attributes: this.getAttributes(),
                i18nAttributes: this.attributes.i18nAttributes,
              },
              context: buildParticipantContextFromGrape(i18n),
            },
            editor.Canvas.getDocument(),
          )}
        </div>`;
      },
    },
  });
}
